import React, { useState, useRef } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { unitPrice, getLowerPrice, getDelPrice, isPromotion, getProductUrl } from '../../../../../../utils/product'
import { useLanguage, useWebp } from '../../../../../hooks/common'
import withItemScroll from '../../../../../hocs/item-scroll'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { IMAGE_GEEKO_LTD } from '../../../../../../constants/index'
import { FormattedMessage } from 'react-intl'
import CartIcon from '../../../../../pages/listing/components/cart/cart-icon'
import { Iconfont } from '../../../../../components/icon/iconfont'
import FaceBookShare from "../../../listing/components/tools/share-to-face"
import withAddToWish from '../../../listing/components/tools/add-to-wish'
import { useSelector } from 'react-redux'
import BuyIcon from "../../../listing/components/cart/cart-icon"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from "swiper";


export const EmptyItem = props => {
    useStyles(classes)
    return <div className={classes.EmptyItem} />
}

const WishIcon = withAddToWish(props => {
    const { addToWishList, hasExistInWishList } = props
    return <span className={classes.Tool} onClick={addToWishList}>
        {
            hasExistInWishList ? <Iconfont style={{
                color: 'rgb(230, 69, 69)'
            }} className={classes.Icon}>&#xe67b;</Iconfont> : <Iconfont className={classes.Icon}>&#xe62c;</Iconfont>
        }
    </span>
})

const FaceIcon = props => {
    const { shareUrl } = props
    return <FaceBookShare shareUrl={shareUrl}>
        <span className={classes.Tool}>
            <Iconfont className={classes.Icon}>&#xe628;</Iconfont>
        </span>
    </FaceBookShare>
}


const Tools = props => {
    useStyles(classes)
    const { product, product_type, position, selectedColor } = props
    const isProm = isPromotion(product)
    const promotionType = isProm ? product.promotion.type : ''
    const global = useSelector(state => state.global)
    const { config } = global


    return <div className={classes.Tools}>
        <WishIcon productId={product?.id} product_type={product_type} />
        <div className={classes.Group}>
            <CartIcon
                render={() => <span className={classes.Tool}>
                    <Iconfont className={classes.Icon}>&#xe62a;</Iconfont>
                </span>}
                sensors={
                    {
                        layerName: product?.layerName,
                        promotionType,
                        trackingRecords: product?.trackingRecords,
                        dataSource: product?.dataSource,
                        geekoExperimentId: product?.geekoExperimentId,
                        geekoRequsestId: product?.geekoRequsestId,
                        aliRequestId: product?.aliRequestId,
                        aliExperimentId: product?.aliExperimentId,
                        position: position + 1
                    }
                } product_type={product_type} productId={selectedColor?.productId || product.id} color={selectedColor ? selectedColor.color : product?.variants?.[0]?.color} />

            <FaceIcon shareUrl={`${config?.root}${getProductUrl(product?.id, product?.name)}`} />
        </div>
    </div>
}

const ColorSwiper = props => {
    useStyles(classes)
    const { product, colors, selectedColor, onColor } = props

    const isNavigation = colors?.length > 3;

    return <div className={classes.ColorContainer}>
        <div className={classes.Colors}>
            {
                isNavigation && <span className={classes.Prev} id="beauty-product-prev">
                    <Iconfont>&#xe693;</Iconfont>
                </span>
            }
            
            <Swiper
                spaceBetween={8}
                slidesPerView={3}
                className={classes.SwiperContainer}
                navigation={{
                    prevEl: '#beauty-product-prev',
                    nextEl: '#beauty-product-next',
                    disabledClass:classes.NavigationDisabled
                }} 
                modules={[Navigation]}
            >
                {
                    colors?.map((color, index) => <SwiperSlide className={classes.ColorSlide} key={index}>
                        <a className={`${classes.ColorImage} ${color.productId === selectedColor?.productId ? classes.Active : ''}`}
                            href={getProductUrl(selectedColor?.productId, product?.name, color.color)}
                            onMouseOver={evt => onColor(color)}
                        >
                            <LazyLoadImage src={color.colorImage} alt={color.color} />
                        </a>
                    </SwiperSlide>)
                }
            </Swiper>
            
            {
                isNavigation && <span id="beauty-product-next" className={classes.Next}>
                    <Iconfont>&#xe694;</Iconfont>
                </span>
            }
        </div>
    </div>
}

export default withItemScroll(props => {
    useStyles(classes)

    const { product, position, column, sensors, product_type, innerRef } = props

    const language = useLanguage()

    const { differentColorStyleVariants } = product

    const [selectedColor, setSelectedColor] = useState(differentColorStyleVariants?.find(v => v.productId === product.id))
    const [hovered, setHovered] = useState(false)

    const isWebp = useWebp() && selectedColor?.status === '1'

    const [lowerPrice, delPrice, isProm] = [
        getLowerPrice(product),
        getDelPrice(product),
        isPromotion(product)
    ]

    let off = 0
    if (delPrice) {
        off = Math.round((Number(delPrice.amount) - Number(lowerPrice.amount)) * 100 / Number(delPrice.amount))
    }


    const url = getProductUrl(selectedColor?.id || product?.id, product?.name, selectedColor?.color, '', language)


    const promotionType = isProm ? product.promotion.type : ''

    const isActivePromotion = isProm && !product?.promotion?.countdownHidden

    const priceClass = isActivePromotion ? classes.FlashPrice : (off > 0 ? classes.PromotionPrice : classes.Price)

    const imageUrl = `${IMAGE_GEEKO_LTD}${isWebp ? '/webp' : ''}/medium/${selectedColor?.mainImage || product?.pcMainImage}`
    const secondaryImageUrl = `${IMAGE_GEEKO_LTD}${isWebp ? '/webp' : ''}/medium/${selectedColor?.pcMainImage2 || product?.pcMainImage2}`

    const appExclusiveZone = selectedColor?.appExclusiveZone || product?.appExclusiveZone


    return <figure className={`${classes.NormalItem} ${position === 0 ? classes.FirstImage : ''}`}>
        <a
            href={url} ref={innerRef}
            product-id={product?.id}
            data-product-list-source
            data-promotion={promotionType}
            data-layer={product?.layerName}
            data-tracking={product.trackingRecords}
            data-product-source={product.dataSource}
            data-geeko-experiment={product.geekoExperimentId}
            data-geeko-id={product.geekoRequsestId}
            data-request-id={product.aliRequestId}
            data-experiment-id={product.aliExperimentId}
            data-column={column}
            data-product-position={position + 1}
            data-position={sensors?.position}
            data-type={sensors?.type}
            data-content={sensors?.refId}
            data-title={sensors?.title}
            data-product-type={product_type}
        >

            <div onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                className={classes.Image}>
                {
                    position === 0 ? <img src={hovered ? secondaryImageUrl : imageUrl} alt={product?.name} /> : <LazyLoadImage src={hovered ? secondaryImageUrl : imageUrl} alt={product?.name} />
                }
                {
                    product.combinatorialPromotion && product.combinatorialPromotion.enabled && <div className={classes.CombinatorialPromotion}>
                        {product?.combinatorialPromotion?.title}
                    </div>
                }
            
                {
                    product.flag ? (
                        <span className={`${classes.OffTip} ${classes.PreFall}`}>{product.flag}</span>
                    ) : (
                        <React.Fragment>
                            {
                                product.isNew && <span className={classes.New}><FormattedMessage id="new" defaultMessage="New" /></span>
                            }

                            {
                                !product.isNew && isActivePromotion && <span style={{ backgroundColor: '#fed157', color: '#222' }} className={classes.OffTip}>{`-${off}%`}</span>
                            }


                            {
                                !product.isNew && !isActivePromotion && off > 0 && <span className={classes.OffTip}>{`-${off}%`}</span>
                            }
                        </React.Fragment>
                    )
                }

                {/* {
                   
                   hovered && <div className={classes.AbsoluteTools}>
                        <Tools
                            product={product}
                            selectedColor={selectedColor}
                            product_type={product_type}
                            position={position}
                        />
                    </div>
                } */}
            </div>
        </a>
        <figcaption>
            <div className={classes.Name}>{product.name}</div>
            <div className={classes.Prices}>
                <span className={priceClass}>{unitPrice(lowerPrice)}</span>
                {
                    delPrice && <del className={classes.Del}>{unitPrice(delPrice)}</del>
                }
            </div>
            {
                differentColorStyleVariants && differentColorStyleVariants.length > 1 && <ColorSwiper product={product} onColor={c => { setSelectedColor(c) }} selectedColor={selectedColor} colors={differentColorStyleVariants} />
            }
            <div>
            {
                appExclusiveZone && appExclusiveZone.enable && <div className={classes.AppExclusive}>
                    <span dangerouslySetInnerHTML={{ __html: appExclusiveZone.message }} />
                </div>
            }
            </div>
        </figcaption>

        <BuyIcon sensors={
            {
                layerName: product?.layerName,
                promotionType,
                trackingRecords: product?.trackingRecords,
                dataSource: product?.dataSource,
                geekoExperimentId: product?.geekoExperimentId,
                geekoRequsestId: product?.geekoRequsestId,
                aliRequestId: product?.aliRequestId,
                aliExperimentId: product?.aliExperimentId,
                position: position
            }
            } productId={selectedColor ? selectedColor.productId :product.id} color={selectedColor? selectedColor.color :product?.variants?.[0]?.color}
            render={() =>{
                return <span className={classes.BeautyLookAddCart}><FormattedMessage id="add_to_bag" defaultMessage="add to bag" /></span>
            }}
        />
    </figure>
})